import React, {useContext, useState, useEffect} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import VendorTable from './tables/VendorTable';
import VendorImports from './tables/VendorImports';
import {VendorContext} from '../../context/VendorProvider';

export default function Vendors() {
  const {data} = useContext(VendorContext);
  const [currentView, setCurrentView] = useState('table');
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const view = params.get('view');
    setCurrentView(view === 'imports' ? 'imports' : 'table');
  }, [location.search]);

  const handleSwitchToImports = () => {
    setCurrentView('imports');
    navigate('/vendors?view=imports', {replace: true});
  };

  const handleSwitchToTable = () => {
    setCurrentView('table');
    navigate('/vendors?view=table', {replace: true});
  };

  return (
    <div className="mx-auto w-full bg-gray-100 dark:bg-stone-800">
      <div className="mx-auto">
        {currentView === 'table' ? (
          <VendorTable
            data={data}
            onSwitchToImports={handleSwitchToImports}
          />
        ) : (
          <VendorImports onSwitchToTable={handleSwitchToTable}/>
        )}
      </div>
    </div>
  );
}